import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prog-steps-new',
  templateUrl: './prog-steps-new.component.html',
  styleUrls: ['./prog-steps-new.component.css']
})
export class ProgStepsNewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
